import AppProvider from 'contexts/app';
import AppBarProvider from 'contexts/appBar';
import { useAuth } from 'contexts/auth';
import DialogProvider from 'contexts/dialog';
import JoyrideProvider from 'contexts/joyride';
import NavigationGuardProvider from 'contexts/navigationGuard';
import ViewportProvider from 'contexts/viewport';
import WebsocketProvider from 'contexts/websocket';

const ProviderWrapper = ({ children }) => {
    const { auth } = useAuth();

    return (
        <ViewportProvider>
            <AppBarProvider>
                <DialogProvider>
                    <NavigationGuardProvider>
                        {auth ? (
                            <WebsocketProvider>
                                <AppProvider>
                                    <JoyrideProvider>{children}</JoyrideProvider>
                                </AppProvider>
                            </WebsocketProvider>
                        ) : (
                            children
                        )}
                    </NavigationGuardProvider>
                </DialogProvider>
            </AppBarProvider>
        </ViewportProvider>
    );
};

export default ProviderWrapper;
